<template>
    <b-row>
        <b-col><h5>Total Audiencia {{ audienceSize }}</h5></b-col>
        <b-col><h5>Cobertura {{ coverage }} ({{ Math.round(coveragePercentaje, 2) }}%)</h5></b-col>
    </b-row>
</template>
<script>
export default {
    props: {
        audienceSize: {
            type: Number,
            default: 0
        },
        coverage: {
            type: Number,
            default: 0
        },
        coveragePercentaje: {
            type: Number,
            default: 0
        }
    }
}
</script>